const toast = {
    types: {
        success: {
            backgroundColor: 'GREEN_700',
            hoverColor: 'GREEN_900',
        },
        alert: {
            backgroundColor: 'RED_700',
            hoverColor: 'RED_900',
        },
        warning: {
            backgroundColor: 'YELLOW_700',
            hoverColor: 'YELLOW_900',
        },
        information: {
            backgroundColor: 'BLUE_700',
            hoverColor: 'BLUE_900',
        },
    },
};
export default toast;
//# sourceMappingURL=toast.js.map